<script setup>
import { computed, inject } from 'vue';
import ModalSimple from '@/components/ModalSimple.vue';
import ThumbnailHeader from '@/components/cifra/ThumbnailHeader.vue';
import EstadisticasAlumno from './EstadisticasAlumno.vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  alumno: {
    type: Object,
    default: null,
  },
  asignatura: {
    type: Object,
    default: null,
  },
  idEvaluacion: {
    type: Number,
    default: null,
  },
  fecha: {
    type: String,
    default: null,
  },
});

const I18n = inject('I18n');
const emits = defineEmits(['update:modelValue']);

const subtitulo = computed(() => {
  let texto = I18n.t('Estadisticas');
  if (props.asignatura) {
    texto += ` - ${props.asignatura.nombre}`;
  }
  return texto;
});

const showModal = computed({
  get: () => props.modelValue,
  set: (value) => emits('update:modelValue', value),
});
</script>

<template>
  <ModalSimple
    id="modal-estadisticas"
    v-model="showModal"
    tamano="lg"
  >
    <ThumbnailHeader
      v-if="showModal && alumno"
      :imagen="alumno.foto_url"
      :titulo="alumno.nombreCompleto"
      :subtitulo="subtitulo"
      tamano="md"
      class="cabecera border-bottom-gris p-b-sm"
    />
    <EstadisticasAlumno
      v-if="showModal"
      :alumno="alumno"
      :id-asignatura="asignatura?.id"
      :id-evaluacion="idEvaluacion"
      :fecha="fecha"
    />
  </ModalSimple>
</template>

<style lang="scss" scoped>
@import '@/components/cuadernos/constantes_cuaderno.scss';

#modal-estadisticas {
  .cabecera {
    margin-top: 0 !important;
  }
}
</style>
